import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Contenido 100% argentino: CAREM-25, CNEA, Atucha, Embalse, INVAP, RA-3 Ezeiza, Instituto Balseiro', 'Material imprimible: Listo para usar en el aula o entregar al alumno', 'Fichas de referencia rápida: Para consultar mientras enseñás', 'Ejercicios resueltos paso a paso: Con datos reales argentinos y latinoamericanos', 'Vocabulario técnico explicado: Sin tecnicismos innecesarios para el nivel del aula', 'Conexión con la actualidad: CAREM-25 en construcción, RA-10, Plan Nuclear 2026, SMR, fusión', 'Contexto histórico argentino: 75 años de soberanía nuclear: CNEA, Balseiro, INVAP, Atucha', '5 Bonos estratégicos: Actividades, casos, infografías, evaluaciones y guía didáctica', 'Garantía de 7 días: Sin preguntas ni formularios', 'Acceso inmediato: Descarga directa tras la compra', 'Actualizaciones gratuitas: Acceso de por vida al material'];
  return <section className="py-12 bg-base border-y border-surface" data-id="element-176">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-177">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-178">
          ✅ TODOS LOS TOMOS INCLUYEN
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-179">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-surface transition-colors" data-id="element-180">
              <CheckCircle2 className="w-5 h-5 text-neon shrink-0 mt-0.5" data-id="element-181" />
              <span className="text-muted font-medium" data-id="element-182">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}